import React from 'react';
import ReactECharts from 'echarts-for-react';

const ComparisonRadarChart = ({ data, reports }) => {
  // Extract unique section titles across all selected reports
  const allSections = Array.from(
    new Set(reports.flatMap(r => r.sections.map(s => s.title)))
  );

  const option = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      data: reports.map(r => r.assessmentTitle),
      bottom: 0
    },
    radar: {
      indicator: allSections.map(section => ({
        name: section,
        max: 100
      })),
      shape: 'circle',
      splitNumber: 5,
      axisName: {
        color: '#64748b'
      },
      splitLine: {
        lineStyle: {
          color: [
            'rgba(203, 213, 225, 0.4)',
            'rgba(203, 213, 225, 0.4)',
            'rgba(203, 213, 225, 0.4)',
            'rgba(203, 213, 225, 0.4)',
            'rgba(203, 213, 225, 1)'
          ].reverse()
        }
      },
      splitArea: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(203, 213, 225, 0.4)'
        }
      }
    },
    series: [
      {
        name: 'Assessment Comparison',
        type: 'radar',
        data: reports.map((report, idx) => {
          const colors = ['#3b82f6', '#10b981', '#f59e0b'];
          return {
            value: allSections.map(section => {
              const s = report.sections.find(sec => sec.title === section);
              return s ? s.score : 0;
            }),
            name: report.assessmentTitle,
            itemStyle: { color: colors[idx % colors.length] },
            areaStyle: {
              opacity: 0.1
            }
          };
        })
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: '400px', width: '100%' }} />;
};

export default ComparisonRadarChart;